export const CafFormConstants = {
  FETCH_CAF_FORM_REQUEST: "FETCH_CAF_FORM_REQUEST",
  FETCH_CAF_FORM_SUCCESS: "FETCH_CAF_FORM_SUCCESS",
  FETCH_CAF_FORM_FAILURE: "FETCH_CAF_FORM_FAILURE",
  ADD_CAF_FORM_REQUEST: "ADD_CAF_FORM_REQUEST",
  ADD_CAF_FORM_SUCCESS: "ADD_CAF_FORM_SUCCESS",
  ADD_CAF_FORM_FAILURE: "ADD_CAF_FORM_FAILURE",
  CAF_FORM_SEARCH_REQUEST: "CAF_FORM_SEARCH_REQUEST",
  CAF_FORM_SEARCH_SUCCESS: "CAF_FORM_SEARCH_SUCCESS",
  CAF_FORM_SEARCH_FAILURE: "CAF_FORM_SEARCH_FAILURE",
  CAF_FORM_AUTO_SEARCH_REQUEST: "CAF_FORM_AUTO_SEARCH_REQUEST",
  CAF_FORM_AUTO_SEARCH_SUCCESS: "CAF_FORM_AUTO_SEARCH_SUCCESS",
  CAF_FORM_AUTO_SEARCH_FAILURE: "CAF_FORM_AUTO_SEARCH_FAILURE",
  GET_CAF_FORM_REQUEST: "GET_CAF_FORM_REQUEST",
  GET_CAF_FORM_SUCCESS: "GET_CAF_FORM_SUCCESS",
  GET_CAF_FORM_FAILURE: "GET_CAF_FORM_FAILURE",
  UPDATE_CAF_FORM_REQUEST: "UPDATE_CAF_FORM_REQUEST",
  UPDATE_CAF_FORM_SUCCESS: "UPDATE_CAF_FORM_SUCCESS",
  UPDATE_CAF_FORM_FAILURE: "UPDATE_CAF_FORM_FAILURE",
  DOWNLOAD_CAF_FORM_REQUEST: "DOWNLOAD_CAF_FORM_REQUEST",
  DOWNLOAD_CAF_FORM_SUCCESS: "DOWNLOAD_CAF_FORM_SUCCESS",
  DOWNLOAD_CAF_FORM_FAILURE: "DOWNLOAD_CAF_FORM_FAILURE",
  UPLOAD_CAF_FORM_REQUEST: "UPLOAD_CAF_FORM_REQUEST",
  UPLOAD_CAF_FORM_SUCCESS: "UPLOAD_CAF_FORM_SUCCESS",
  UPLOAD_CAF_FORM_FAILURE: "UPLOAD_CAF_FORM_FAILURE",
  PREVIEW_KYC_REQUEST: "PREVIEW_KYC_REQUEST",
  PREVIEW_KYC_SUCCESS: "PREVIEW_KYC_SUCCESS",
  PREVIEW_KYC_FAILURE: "PREVIEW_KYC_FAILURE",
  APPROVE_CAF_FORM_REQUEST: "APPROVE_CAF_FORM_REQUEST",
  APPROVE_CAF_FORM_SUCCESS: "APPROVE_CAF_FORM_SUCCESS",
  APPROVE_CAF_FORM_FAILURE: "APPROVE_CAF_FORM_FAILURE",
  REJECT_CAF_FORM_REQUEST: "REJECT_CAF_FORM_REQUEST",
  REJECT_CAF_FORM_SUCCESS: "REJECT_CAF_FORM_SUCCESS",
  REJECT_CAF_FORM_FAILURE: "REJECT_CAF_FORM_FAILURE",
};
